import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { LocalizedStringPipe } from "./localized-string.pipe";

@NgModule({
  declarations: [
    LocalizedStringPipe,
  ],
  exports: [
    LocalizedStringPipe,
  ],
  imports: [
    CommonModule,
    TranslateModule,
  ],
})
export class LocalizedStringPipeModule {

}